function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Components",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.125-9.562a1.688 1.688 0 0 1-1.687 1.687h-3.375a1.688 1.688 0 0 1-1.688-1.687v-3.375a1.687 1.687 0 0 1 1.688-1.687h3.375a1.688 1.688 0 0 1 1.688 1.688zm0 9a1.688 1.688 0 0 1-1.687 1.687h-3.375A1.688 1.688 0 0 1-7.875-.562v-3.375a1.688 1.688 0 0 1 1.688-1.688h3.375a1.688 1.688 0 0 1 1.687 1.688zm9 0a1.688 1.688 0 0 1-1.687 1.687H2.813A1.688 1.688 0 0 1 1.125-.562v-3.375a1.688 1.688 0 0 1 1.688-1.688h3.375a1.688 1.688 0 0 1 1.687 1.688z",
    transform: "translate(12 19)",
    style: {
      fill: "#778187"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Symbol",
    d: "M2.813-13.125a.188.188 0 0 0-.187.188v3.375a.188.188 0 0 0 .188.188h3.374a.188.188 0 0 0 .188-.187v-3.375a.188.188 0 0 0-.187-.187H2.813m0-1.5h3.375a1.688 1.688 0 0 1 1.688 1.688v3.375a1.688 1.688 0 0 1-1.688 1.685H2.813a1.688 1.688 0 0 1-1.688-1.687v-3.375a1.688 1.688 0 0 1 1.688-1.688z",
    transform: "translate(12 19)",
    style: {
      fill: "#778187"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuComponents);
export default __webpack_public_path__ + "static/media/IconMenuComponents.43dac7d36b627382ee8ff362c76e8cba.svg";
export { ForwardRef as ReactComponent };